// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2741) return "static/chunks/2741.ad9135a793066caa.js";
	if (chunkId === 6184) return "static/chunks/6184.e848118901bc2cef.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7674 ? "ca377847" : chunkId) + "-" + {"2153":"79d8223d628250ba","2710":"21ed0b5e10b605a9","7674":"f0ff5535ca97ddf5"}[chunkId] + ".js";
};